<template>
  <!-- 添加-编辑资质文章 -->
  <div class="container ">
    <div class="vue">
      <div class="header padHorizontal10 flex flexJc-sb flexAi-c">
        <div class="text">{{ title }}</div>
        <div class="padR10">
          <el-button size="mini" @click="goBack" icon="el-icon-back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="content flex flexAi-c">
        <el-form
          :rules="rules"
          size="small"
          ref="formInfo"
          :model="formInfo"
          label-width="80px"
        >
          <el-form-item label="文章名称" prop="name">
            <el-input v-model="formInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="文章图片" prop="icon">
            <div class="image">
              <el-upload
                action="#"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :file-list="fileList"
                :on-remove="handleRemove"
                :limit="1"
                :http-request="uploadSectionFile"
                :on-exceed="handleExceed"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>

                <!-- <div class="addimage flex flexColumn flexAi-c flexJc-c">
                  <el-image
                    class="image flex"
                    :src="require('@/assets/ProductManage/tjtp.png')"
                  ></el-image>
                  <span class="text">添加图片</span>
                </div> -->
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="文章详情" prop="content">
            <vue-ueditor-wrap
              class="ueditor"
              v-model="formInfo.content"
              :config="myConfig"
            ></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="confirmBut('formInfo')"
              >确定</el-button
            >
            <el-button @click="goBack">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import { apiUploadByBase64 } from '@/api/uploading'
import {
  apiAddSptitude,
  apiGetSptitude,
  apiEditAptitude
} from '@/api/articleManage'
let _self
export default {
  name: '',
  props: [''],

  data() {
    return {
      title: '添加文章',
      routeData: '',
      uploadActionUrl: '',
      formInfo: {
        name: '',
        icon: '',
        content: '' // 内容
      },
      rules: {
        name: [{ required: true, message: '请输入栏目名', trigger: 'blur' }],
        icon: [{ required: true, message: '请添加栏目图片', trigger: 'blur' }],
        content: [
          { required: true, message: '请添加栏目图片', trigger: 'blur' }
        ]
      },
      myConfig: {
        UEDITOR_HOME_URL: '/UEditor/',
        serverUrl: '',
        // 工具栏是否可以浮动
        autoFloatEnabled: false
      },
      videoFlag: false, //
      columnList: [], // 栏目列表
      fileList: [],
      imageUrl: '',
      dialogVisible: false,
      imageUpload: '',
      disabled: false,
      msg: ''
    }
  },
  components: { VueUeditorWrap },
  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    // uedit富文本上传图片需要和后端协助
    this.myConfig.serverUrl = _self.baseURL + '/ueditor/ueditorUpload.do'
    if (this.$route.query.info !== undefined) {
      this.title = '编辑文章'
      _self.routeData = JSON.parse(this.$Base64.decode(this.$route.query.info))
      this.GetSptitude()
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    addimageBut() {},
    /**
     * 文件上传-自定义上传行为
     * */
    uploadSectionFile(params, file1) {
      if (_self.fileList.length > 0) {
        this.$message.error('最高可上传一个图片')
        return
      }
      console.log(params)
      console.log(file1)
      const file = params.file
      const fileType = file.type
      const isImage = fileType.indexOf('image') !== -1
      console.log(file)
      const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      // if (!isImage) {
      //   this.$message.error('只能上传图片格式png、jpg、gif!')
      //   return
      // }
      // if (!isLt2M) {
      //   this.$message.error('只能上传图片大小小于2M')
      //   return
      // }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function(e) {
        // const _self = this
        // this.result // 这个就是base64编码了
        let imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: imageUrl,
          path: 'BackstageSptitude'
        }).then(res => {
          if (res.status === 0) {
            _self.$message({
              message: '图片上传成功',
              type: 'success'
            })
            _self.formInfo.icon = res.data
            _self.fileList[0] = res.data
          }
        })
      }
    },
    // 删除文件之前的钩子
    handleRemove(file, fileList) {
      _self.fileList = []
      _self.formInfo.img = ''
    },
    // 文件超出个数限制时的钩
    handleExceed(file, fileList) {
      console.log(fileList)
      console.log(this.fileList)
      this.$message.error('最高可上传一个图片')
    },
    editorClick(e) {
      // console.log(e)
    },
    // 按钮
    // 确定提交按钮
    confirmBut(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 不为空走编辑
          if (this.routeData !== '') {
            apiEditAptitude({
              id: this.routeData.id,
              name: this.formInfo.name,
              icon: this.formInfo.icon,
              content: this.formInfo.content
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.formInfo = {
                  name: '',
                  icon: '',
                  content: '' // 内容
                }
                this.fileList = []
                this.$router.go(-1)
              } else if (res.status === 1) {
                this.$Me(res.msg)
              }
              this.dialogColumn = false
            })
          } else {
            apiAddSptitude({
              name: this.formInfo.name,
              icon: this.formInfo.icon,
              content: this.formInfo.content
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.formInfo = {
                  name: '',
                  icon: '',
                  content: '' // 内容
                }
                this.fileList = []
                this.$router.go(-1)
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /** 接口 */
    // 获取动态的详细信息
    GetSptitude() {
      apiGetSptitude({
        id: this.routeData.id
      }).then(res => {
        _self.formInfo.name = res.data.name
        _self.formInfo.icon = res.data.icon
        _self.formInfo.content = res.data.content
        _self.fileList = [{ url: _self.baseImage + res.data.icon }]
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.FZ0875 {
  font-size: 0.875em;
}
.vue {
  height: calc(100vh - 120px);
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    line-height: 40px;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
    }
  }
  .content {
    background: #fff;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-form {
      width: 60%;
      /deep/ .el-form-item__content {
        .el-input-number {
          width: 100%;
          input {
            text-align: left;
          }
        }
        .addimage {
          height: 100%;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .el-image {
            width: 30px;
            height: 30px;
          }
          .text {
            padding: 0;
            padding-top: 10px;
            width: 100%;
            line-height: normal;
          }
        }
      }
    }
  }
}
</style>
